export const getMessageTypeGoals = (
  t: (arg1: string, arg2: string) => string,
): {
  survey: string;
  chatbot: string;
  email_with_links: string;
  email_no_links: string;
  sms: string;
  email: string;
} => {
  return {
    survey: t('Completion', 'Completion'),
    chatbot: t('Completion', 'Completion'),
    email_with_links: t('Click', 'Click'),
    email_no_links: t('Open', 'Open'),
    sms: t('Reply', 'Reply'),
    email: `${t('Unknown', 'Unknown')} (${t(
      'Click_or_Open',
      'Click or Open',
    )})`,
  };
};
